import styles from "./Button.module.css";

export const Button = ({type = "primary", children, className, onClick, disabled}) => {
  return (
    <button
      disabled={disabled}
      className={`${styles[type]} ${className} hover:scale-105 active:brightness-75`}
      onClick={onClick}>
      {children}
    </button>
  );
};
